"use client";

import { Translate } from "@/components/Translate";
import { useIsPreorder } from "@/features/products/hooks";
import styles from "./PreorderTag.module.css";

export interface PreorderTagProps {
	centraVariantId?: string;
	displayItemId: string;
	isBundle: boolean;
}

export const PreorderTag = ({
	centraVariantId,
	displayItemId,
	isBundle,
}: PreorderTagProps) => {
	const { data: preorderData } = useIsPreorder({
		centraVariantId: centraVariantId,
		displayItemId,
		isBundle,
	});

	if (!preorderData) return null;

	return (
		<span className={styles.root}>
			<Translate>Pre-order</Translate>
		</span>
	);
};
